import React from 'react';

const withUrlParser = (Component: React.FunctionComponent<any>) => {
  const WithUrlParser = (props: any) => {
    const convertUrlsToAnchorTags = (text: string) => {
      if (!text) {
        return;
      }

      const urlsRegEx = /\bhttps?:\/\/\S+/gi;
      const foundUrls = text.match(urlsRegEx);

      if (!foundUrls || foundUrls.length === 0) {
        return text;
      }

      const parts: any[] = text.split(' ');

      foundUrls.forEach((url) => {
        const index = parts.indexOf(url);
        parts.splice(
          index,
          1,
          <a href={url} target='_blank' rel='noreferrer'>
            {url}
          </a>,
        );
      });

      return (
        <>
          {parts.map((p) => {
            const key = Math.random().toString();
            if (typeof p === 'string') {
              return <React.Fragment key={key}>{` ${p} `}</React.Fragment>;
            }
            return <React.Fragment key={key}>{p}</React.Fragment>;
          })}
        </>
      );
    };

    return (
      <Component {...props} convertUrlsToAnchorTags={convertUrlsToAnchorTags} />
    );
  };

  return WithUrlParser;
};

export default withUrlParser;
